import { ISelectable } from "../tools/selectable";
import { ELIMSResult } from "./ELIMS-result";
import { FDXMeasureCategory } from "./enum/fdx-measure-category";
import { EFrequency } from "./enum/frequency";
import { EMeasureCategory } from "./enum/measure-category";
import { EMeasureParentType } from "./enum/measure-parent-type";
import { ESiteType } from "./enum/site-type";
import { EZoneUsage } from "./enum/zone-usage";

export class ClientMeasure implements ISelectable {
    /**
     * LocalID is just for the client side of the application because we don't have a samplingID yet
     */
    localID: number;
    IsSelected: boolean;
    SamplingId: number;
    ParentId: number;
    MeasureReferenceCode: string;
    MeasureReferenceName: string;
    MeasureReferenceDesignation: string;
    ELIMSResult: ELIMSResult;
    ParentType: EMeasureParentType;
    ParentName: string;
    ParentDescription: string;
    ZoneUsage: EZoneUsage;
    Frequency: EFrequency = EFrequency.Day
    ProcessType: ESiteType;
    SamplingDate: Date;
    SampleCode: string;
    PumpWithBattery: boolean;
    Rush: boolean;
    HasAreaMap: boolean;
    AreaMapName: string;
    ChipName: string;
    TextColor: string;
    Color: string;
    IsComplementary: boolean;
    IsDepose: boolean;
    /**DEPRECATED */
    // HasCustomerRef: boolean;

    // DISPATCH
    EDIAnalysisNumber: string;
    HasFan: boolean;
    // !DISPATCH
    Category: FDXMeasureCategory | EMeasureCategory;
    GroupName: string;
    IsAccredited: boolean;
    CustomerRef: string
    IsPrestationAnnexe: boolean;

    IsExotic() {
        return this.ParentType === EMeasureParentType.Lingette || this.ParentType === EMeasureParentType.Eau || this.ParentType === EMeasureParentType.Massif
    }

    static mapFromJSON(json): ClientMeasure {
        const cm = new ClientMeasure;

        cm.IsAccredited = json['isAccredited'];
        cm.GroupName = json['groupName'];
        cm.SamplingId = json['samplingId'];
        cm.ParentId = json['parentId'];
        cm.MeasureReferenceCode = json['measureReferenceCode'];
        cm.MeasureReferenceName = json['measureReferenceName'];
        cm.MeasureReferenceDesignation = json['measureReferenceDesignation'];
        cm.ChipName = json['measureReferenceChipName'];
        cm.Color = `#${json['measureReferenceColor']}`;
        cm.TextColor = `#${json['measureReferenceTextColor']}`;
        cm.ParentType = json['parentType'];
        cm.ParentName = json['parentName'];
        cm.ParentDescription = json['parentDescription'];
        cm.ZoneUsage = json['zoneUsage'] === null ? 0 : json['zoneUsage'];
        cm.ProcessType = json['processType'];
        cm.SamplingDate = json['samplingDate'] ? new Date(json['samplingDate']) : undefined;
        cm.SampleCode = json['sampleCode'];
        cm.PumpWithBattery = json['pumpWithBattery'];
        cm.Rush = json['rush'];
        cm.HasAreaMap = json['hasAreaMap'];
        cm.AreaMapName = json['areaMapName'];
        cm.IsComplementary = json['isComplementary'];
        cm.EDIAnalysisNumber = json['ediAnalysisNumber'];
        cm.HasFan = json['hasFan'];
        cm.IsDepose = json['isDepose'];
        cm.Category = json['measureCategory']
        cm.CustomerRef = json['customerRef']
        cm.Frequency = json['frequency'];
        cm.IsPrestationAnnexe = json['isPrestationAnnexe'];

        if (json['limsResult']) {
            cm.ELIMSResult = ELIMSResult.mapFromJSON(json['limsResult']);
        }

        return cm;
    }
}
